import React, { FC } from 'react'
import area from '@turf/area'
import { Text } from 'components/Text'
import { readableNumber } from 'utils/readableNumber'
import { Feature } from 'models/map'

type PolygonDescriptionProps = {
  selectedFeature: Feature
}

export const PolygonDescription: FC<PolygonDescriptionProps> = ({ selectedFeature }) => {
  const totalArea = readableNumber(area(selectedFeature as any) / 1e6)

  return <Text>{totalArea} km2</Text>
}

PolygonDescription.displayName = 'PolygonDescription'
